import { Component, OnInit } from '@angular/core';
import { MatchService } from '../match.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-d-matches',
  templateUrl: './d-matches.component.html',
  styleUrls: ['./d-matches.component.css']
})
export class DMatchesComponent implements OnInit {
  matchList: any;
  match: any;
  lotusMatchList: any;
  isLoading = false;
  constructor(private matchService: MatchService) { }

  ngOnInit() {
    this.lotusMatchList = [];
    this.isLoading = true;
    this.matchService.getAllDMatches().subscribe(response => {
      this.match = response[0]['result'];
      this.matchList = response[1]['result'];
      //let cricket = response[0]['result'];
      //let dCricket = response[1]['result'];
      //this.matchList = this.getCricketMatch(dCricket);

      this.isLoading = false;
    },
      error => {
        //console.log(error);
        this.isLoading = false;
      });

    this.matchService.getAllMatch().subscribe(response => {
      let st = response['result'];
      this.lotusMatchList = this.getSTMatch(st);
    },
      error => {
        this.lotusMatchList = [];
        //console.log(error);
      });
  }

  getCricketMatch = (cricket) => {
    return cricket.filter(e => {
      return e.sportId === '4';
    })
  }

  getSTMatch = (st) => {
    return st.filter(e => {
      return e.sport_id !== '4';
    })
  }

  addMatch(data, inc) {
    //console.log(data);
    let btn = (<HTMLInputElement>document.getElementById('btn' + inc));
    btn.disabled = true;
    let res = this.checkExists(data.eventId);
    if (!res) {
      this.matchService.createDMatch(data).subscribe((response) => {
        btn.innerText = 'Added';
        btn.classList.remove("btn-danger");
        btn.classList.add("btn-success");
        //console.log(response);
        //this.isAlert = true;
        this.msgSuccess();
      }, error => {
        btn.disabled = false;
        this.msgFailure('Something Went Wrong!');
      });
    }
  }

  checkExists = (eventId) => {
    if (this.match) {
      return this.match.some(x => x.eventId === eventId)
    }
    return false;
  }

  getCmpName = (eventId) => {
    return this.lotusMatchList.find(e => {
      return e.event_id === eventId;
    })?.competition_name || '';
  }

  getDate = (eventId) => {
    return this.lotusMatchList.find(e => {
      return e.event_id === eventId;
    })?.open_date || '';
  }

  actionTitle = (eventId) => {
    if (this.match) {
      if (this.match.some(x => x.eventId === eventId)) {
        return 'Added';
      }
      else {
        return 'Add';
      }
    }
    return 'Add';
  }

  showColor = (eventId) => {
    if (this.match) {
      if (this.match.some(x => x.eventId === eventId)) {
        return 'success';
      }
      else {
        return 'danger';
      }
    }
    return 'danger';
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Added!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure(message) {
    swal.fire({
      icon: 'error',
      title: message,
      showConfirmButton: false,
      timer: 1500
    })
  }
}